import { render } from "./ComponentGroup.vue?vue&type=template&id=e03b3552"
import script from "./ComponentGroup.vue?vue&type=script&lang=js"
export * from "./ComponentGroup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__